<div class="dashboard-container">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="48"></mat-spinner>
  </div>

  <!-- Dashboard Content -->
  <div *ngIf="!loading && user" class="dashboard-inner">

    <!-- Welcome Section -->
    <div class="welcome-section">
      <div class="welcome-left">
        <div class="welcome-avatar">
          <mat-icon>person</mat-icon>
        </div>
        <div class="welcome-text">
          <h2>Hallo, {{ user.username }}!</h2>
          <div class="welcome-meta">
            <span class="meta-item">
              <mat-icon>email</mat-icon>
              {{ user.email }}
            </span>
            <span class="meta-item">
              <mat-icon>badge</mat-icon>
              {{ user.roles }}
            </span>
          </div>
        </div>
      </div>
      <div class="welcome-actions">
        <button mat-stroked-button class="btn-password" (click)="resetPassword()">
          <mat-icon>lock</mat-icon>
          Passwort ändern
        </button>
        <button mat-flat-button class="btn-logout" (click)="logout()">
          <mat-icon>logout</mat-icon>
          Abmelden
        </button>
      </div>
    </div>

    <!-- Stats Row -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-icon stat-icon--blue">
          <mat-icon>login</mat-icon>
        </div>
        <div class="stat-info">
          <h3>{{ recentActivities.length }}</h3>
          <p>Anmeldungen</p>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon stat-icon--orange">
          <mat-icon>output</mat-icon>
        </div>
        <div class="stat-info">
          <h3>{{ userWithdrawals.length }}</h3>
          <p>Entnahmen</p>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon stat-icon--green">
          <mat-icon>input</mat-icon>
        </div>
        <div class="stat-info">
          <h3>{{ userReturns.length }}</h3>
          <p>Rückgaben</p>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon stat-icon--red">
          <mat-icon>inventory</mat-icon>
        </div>
        <div class="stat-info">
          <h3>{{ getTotalWithdrawnQuantity() }}</h3>
          <p>Elemente entnommen</p>
        </div>
      </div>
    </div>

    <!-- Kalender teilen -->
    <div class="signature-section">
      <div class="signature-card">
        <div class="signature-header">
          <h3><mat-icon>event</mat-icon> Meinen Kalender teilen</h3>
        </div>
        <p class="feed-hint">
          Fügen Sie hier den <strong>veröffentlichten iCal-/ICS-Link</strong> Ihres Kalenders ein
          (Outlook: „Kalender freigeben/veröffentlichen" → ICS-Link; Google: „Kalendereinstellungen"
          → „Privatadresse im iCal-Format"). Ihre Termine erscheinen dann in der Ressourcenplanung als
          schreibgeschützter „belegt"-Hinweis. Es wird nichts an Ihrem Kalender verändert.
        </p>
        <div class="feed-row">
          <input class="feed-url-input" type="url" placeholder="https://…/calendar.ics"
                 [(ngModel)]="calendarFeedUrl" />
          <button mat-flat-button color="primary" (click)="saveMyFeed()" [disabled]="feedSaving">
            Speichern
          </button>
          <button mat-stroked-button color="warn" *ngIf="calendarFeedUrl" (click)="clearMyFeed()">
            Entfernen
          </button>
        </div>
      </div>
    </div>

    <!-- Abwesenheit beantragen -->
    <div class="signature-section">
      <div class="signature-card">
        <div class="signature-header">
          <h3><mat-icon>beach_access</mat-icon> Abwesenheit / Urlaub</h3>
        </div>
        <p class="feed-hint">
          Beantragen Sie hier Urlaub oder andere Abwesenheiten. Der Antrag geht an Ihren
          Urlaubsgenehmiger (festlegbar unter
          <a routerLink="/ressourcenplanung/abwesenheiten">Ressourcenplanung › Abwesenheiten</a>).
        </p>
        <p class="abs-approver" *ngIf="absencePermissions?.canRequest">
          <mat-icon>{{ absencePermissions?.autoApprove ? 'check_circle' : 'forward_to_inbox' }}</mat-icon>
          <ng-container *ngIf="absencePermissions?.autoApprove">Als Leitung Ihres Hauptteams wird Ihr Urlaub ohne Genehmiger direkt eingetragen.</ng-container>
          <ng-container *ngIf="!absencePermissions?.autoApprove">Genehmiger: <strong>{{ absencePermissions?.effectiveApproverName }}</strong></ng-container>
        </p>
        <p class="abs-approver warn" *ngIf="absencePermissions && !absencePermissions.canRequest" role="alert">
          <mat-icon>warning_amber</mat-icon>
          <span>{{ absencePermissions.requestBlockedReason }}
            <a routerLink="/ressourcenplanung/abwesenheiten">Genehmiger auswählen</a></span>
        </p>

        <div class="abs-form">
          <select class="abs-input" [(ngModel)]="absCategoryId">
            <option *ngFor="let c of absenceCategories" [ngValue]="c.id">{{ c.name }}</option>
          </select>
          <input class="abs-input" type="datetime-local" [(ngModel)]="absStart" placeholder="Von" />
          <input class="abs-input" type="datetime-local" [(ngModel)]="absEnd" placeholder="Bis" />
          <input class="abs-input abs-notes" type="text" [(ngModel)]="absNotes" placeholder="Notiz (optional)" />
          <button mat-flat-button color="primary" (click)="requestAbsence()" [disabled]="!absValid || absSaving || !absCanRequest">
            Beantragen
          </button>
        </div>

        <table class="abs-table" *ngIf="myAbsences.length">
          <thead>
            <tr><th>Art</th><th>Von</th><th>Bis</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let a of myAbsences">
              <td>{{ a.categoryName || a.title }}</td>
              <td>{{ a.start | date:'dd.MM.yyyy HH:mm' }}</td>
              <td>{{ a.end | date:'dd.MM.yyyy HH:mm' }}</td>
              <td>
                <span class="abs-badge" [style.background]="absenceStatusColor(a.approvalStatus)">
                  {{ absenceStatusLabel(a.approvalStatus) }}
                </span>
              </td>
              <td>
                <button mat-icon-button color="warn"
                        *ngIf="a.approvalStatus !== 'None'"
                        (click)="cancelAbsence(a)" matTooltip="Zurückziehen">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="feed-hint" *ngIf="!myAbsences.length">Noch keine Abwesenheiten beantragt.</p>
      </div>
    </div>

    <!-- Signature Section -->
    <div class="signature-section">
      <div class="signature-card">
        <div class="signature-header">
          <h3><mat-icon>draw</mat-icon> Meine Unterschrift</h3>
          <div class="signature-actions">
            <button mat-icon-button *ngIf="signatureUrl" color="warn" (click)="deleteSignature()" matTooltip="Unterschrift löschen">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div *ngIf="signatureUrl && !editingSignature" class="signature-preview">
          <img [src]="signatureUrl" alt="Gespeicherte Unterschrift" class="saved-signature-img">
          <button mat-stroked-button (click)="startEditingSignature()">
            <mat-icon>edit</mat-icon> Unterschrift ändern
          </button>
        </div>

        <div *ngIf="!signatureUrl && !editingSignature" class="signature-empty">
          <mat-icon class="empty-sig-icon">draw</mat-icon>
          <p>Noch keine Unterschrift hinterlegt.</p>
          <button mat-raised-button color="primary" (click)="startEditingSignature()">
            <mat-icon>add</mat-icon> Unterschrift hinzufügen
          </button>
        </div>

        <div *ngIf="editingSignature" class="signature-editor">
          <p class="sig-hint">Bitte hier unterschreiben:</p>
          <div class="signature-canvas-wrapper">
            <canvas #sigCanvas class="signature-canvas"></canvas>
            <button mat-icon-button class="clear-sig" (click)="clearSignatureCanvas()" matTooltip="Neu zeichnen">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
          <div class="signature-editor-actions">
            <button mat-stroked-button (click)="cancelEditingSignature()">Abbrechen</button>
            <button mat-raised-button color="primary" (click)="saveSignature()" [disabled]="!sigDrawn || savingSignature">
              <mat-icon>save</mat-icon> Speichern
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs Section -->
    <div class="dashboard-tabs">
      <mat-tab-group class="tab-header" animationDuration="200ms" (selectedTabChange)="onTabChange($event)">

        <!-- Tab 1: Aktivitäten / Anmeldungen -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">history</mat-icon>
            Aktivitäten
          </ng-template>
          <div class="activity-list" *ngIf="displayedActivities.length > 0; else noActivities">
            <div class="activity-item" *ngFor="let activity of displayedActivities">
              <div class="activity-icon-wrapper activity-icon--login">
                <mat-icon>login</mat-icon>
              </div>
              <div class="activity-details">
                <div class="activity-action">{{ activity.action }}</div>
              </div>
              <div class="activity-date">{{ activity.timestamp }}</div>
            </div>
          </div>
          <ng-template #noActivities>
            <div class="empty-state">
              <div class="empty-icon"><mat-icon>event_busy</mat-icon></div>
              <p>Keine Aktivitäten vorhanden</p>
            </div>
          </ng-template>
          <mat-paginator class="tab-paginator"
                         (page)="handlePageEvent($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [pageSizeOptions]="[5, 10, 25, 50]"
                         [showFirstLastButtons]="true">
          </mat-paginator>
        </mat-tab>

        <!-- Tab 2: Entnahmen -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">output</mat-icon>
            Entnahmen
          </ng-template>

          <div *ngIf="withdrawalsLoading" class="loading-container" style="min-height:200px">
            <mat-spinner diameter="36"></mat-spinner>
          </div>

          <div *ngIf="!withdrawalsLoading && displayedWithdrawals.length > 0">
            <table mat-table [dataSource]="displayedWithdrawals" class="history-table">
              <ng-container matColumnDef="element">
                <th mat-header-cell *matHeaderCellDef>Element</th>
                <td mat-cell *matCellDef="let row">{{ row.element?.name || 'Element #' + row.elementID }}</td>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef>Menge</th>
                <td mat-cell *matCellDef="let row">
                  <span class="quantity-badge quantity-badge--withdrawal">-{{ row.quantity }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="purpose">
                <th mat-header-cell *matHeaderCellDef>Zweck</th>
                <td mat-cell *matCellDef="let row">{{ row.purpose }}</td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Datum</th>
                <td mat-cell *matCellDef="let row">{{ formatDate(row.timestamp) }}</td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let row">
                  <span class="status-badge" [ngClass]="row.isReturned ? 'status-badge--success' : 'status-badge--warning'">
                    {{ row.isReturned ? 'Zurückgegeben' : 'Offen' }}
                  </span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="withdrawalColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: withdrawalColumns"></tr>
            </table>
          </div>

          <div *ngIf="!withdrawalsLoading && displayedWithdrawals.length === 0" class="empty-state">
            <div class="empty-icon"><mat-icon>inventory_2</mat-icon></div>
            <p>Keine Entnahmen vorhanden</p>
          </div>

          <mat-paginator class="tab-paginator"
                         (page)="handleWithdrawalPageEvent($event)"
                         [length]="userWithdrawals.length"
                         [pageSize]="pageSize"
                         [pageSizeOptions]="[5, 10, 25, 50]"
                         [showFirstLastButtons]="true">
          </mat-paginator>
        </mat-tab>

        <!-- Tab 3: Rückgaben -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">input</mat-icon>
            Rückgaben
          </ng-template>

          <div *ngIf="returnsLoading" class="loading-container" style="min-height:200px">
            <mat-spinner diameter="36"></mat-spinner>
          </div>

          <div *ngIf="!returnsLoading && displayedReturns.length > 0">
            <table mat-table [dataSource]="displayedReturns" class="history-table">
              <ng-container matColumnDef="element">
                <th mat-header-cell *matHeaderCellDef>Element</th>
                <td mat-cell *matCellDef="let row">{{ row.element?.name || 'Element #' + row.elementID }}</td>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef>Menge</th>
                <td mat-cell *matCellDef="let row">
                  <span class="quantity-badge quantity-badge--return">+{{ row.quantity }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="reason">
                <th mat-header-cell *matHeaderCellDef>Grund</th>
                <td mat-cell *matCellDef="let row">{{ row.reason }}</td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Datum</th>
                <td mat-cell *matCellDef="let row">{{ formatDate(row.timestamp) }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="returnColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: returnColumns"></tr>
            </table>
          </div>

          <div *ngIf="!returnsLoading && displayedReturns.length === 0" class="empty-state">
            <div class="empty-icon"><mat-icon>assignment_return</mat-icon></div>
            <p>Keine Rückgaben vorhanden</p>
          </div>

          <mat-paginator class="tab-paginator"
                         (page)="handleReturnPageEvent($event)"
                         [length]="userReturns.length"
                         [pageSize]="pageSize"
                         [pageSizeOptions]="[5, 10, 25, 50]"
                         [showFirstLastButtons]="true">
          </mat-paginator>
        </mat-tab>

      </mat-tab-group>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="!loading && !user" class="error-container">
    <mat-icon>error_outline</mat-icon>
    <p>{{ error }}</p>
  </div>
</div>
